// Read-only accessors for public parameters bundled with the frontend
// Replaces the old ParametersContext usage.

import publicParams from './publicParams.json';

export type ParamMap = Record<string, string>;

const params: ParamMap = (publicParams as unknown as ParamMap) || {};

export const paramKeys = {
  siteYearsExperience: 'site.stats.years.experience',
  siteFoundedYear: 'site.stats.founded.year',
  siteHappyCustomers: 'site.stats.happy.customers',
  bulkLessonEndMaxMonths: 'bulk.lesson.end.max.months',
  teacherWorkingDays: 'teacher.working.days',
} as const;

export function getString(key: string, fallback: string): string {
  const v = params[key];
  return typeof v === 'string' ? v : fallback;
}

export function getNumber(key: string, fallback: number): number {
  const v = params[key];
  if (v == null) return fallback;
  const n = Number(v);
  return Number.isFinite(n) ? n : fallback;
}

export function getJson<T>(key: string, fallback: T): T {
  const v = params[key];
  if (!v) return fallback;
  try { return JSON.parse(v) as T; } catch { return fallback; }
}

export function getWorkingDays(fallback: number[] = [1, 2, 3, 4, 5]): number[] {
  return getJson<number[]>(paramKeys.teacherWorkingDays, fallback);
}
